import * as Sentry from '@sentry/browser'

export const captureException = async (error: any) => {
  console.warn(error)

  if (!Sentry) return

  typeof error === 'string'
    ? Sentry.captureMessage(error)
    : Sentry.captureException(error)

  await Sentry.flush()
}
